import React, { PropsWithChildren, useEffect } from 'react';
import './LogoItem.scss';
import ApproveIcons from 'assets/images/approved2.png';
import { Trans, useTranslation } from 'react-i18next';


type Props = {
  name?: string;
  image: string;
  onClick?: (id) => void;
  enabled?
  hasPrice?: boolean;
  tooltipIndex?: string;
  item?

};

const LogoItem: React.FC<Props> = (props: PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  function show(index: string, type: 'block' | 'none') {
    const elements = document.getElementsByClassName(`tooltip-${index}`);

    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.setProperty('display', type, 'important');
    }
  }

  const adjustTooltipPositions = () => {
    const tooltips = document.querySelectorAll('.item-tooltip');

    if (tooltips.length > 0) {
      tooltips.forEach((tooltip) => {
        (tooltip as HTMLElement).style.right = 'auto';
        (tooltip as HTMLElement).style.left = '8rem';
      });

      // Modifică doar ultimul tooltip
      const lastTooltip = tooltips[tooltips.length - 1] as HTMLElement;

      lastTooltip.style.right = '8rem';
      lastTooltip.style.left = 'auto';
    }
  };

  useEffect(() => {
    adjustTooltipPositions();
  }, [props.tooltipIndex]); // Se reaplică la fiecare schimbare a tooltips

  return (
    <div className="item-container" >
      {props.tooltipIndex && (
        <div className={`item-tooltip tooltip-${props.tooltipIndex}`}>
          {props.hasPrice ? (props.item.updated_at ? < Trans i18nKey="_prices_updated_on" values={{ date: props.item.updated_at }} /> : null) : t('_prices_not_available')}
        </div>
      )}


      <div className={`item ${props.enabled ? '' : 'enabled'} ${props.hasPrice ? '' : 'not_available'}`} onClick={props.onClick}
        onMouseEnter={() => {
          if (props.tooltipIndex) {
            show(String(props.tooltipIndex), 'block');
          }
        }}
        onMouseLeave={() => {
          if (props.tooltipIndex) {
            setTimeout(() => {
              show(String(props.tooltipIndex), 'none');
            }, 100);
          }
        }}
      >
        {
          props.hasPrice && <div className="item-approve">
            <img src={ApproveIcons} alt="image" />
          </div>
        }
        <img src={props.image} alt={props.image ? props.image.substring(props.image.lastIndexOf('/')) : '/images/car-part-placeholder.png'} onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = '/images/car-part-placeholder.png';
        }}
        />
        {/*<p>{props.image.substring(props.image.lastIndexOf('/'))+1}  </p>*/}
        <div className="item-name">{props.name}</div>
      </div>


    </div >
  );
};

LogoItem.displayName = 'LogoItem';

export default LogoItem;
